export default {
  computed: {
    isAdmin() {
      return this.authInfo && this.authInfo.role == 'admin'
    },
    isVip() {
      return this.authInfo && this.authInfo.role == 'vip'
    },
    vipExpired() {
      return this.authInfo && this.isVip && this.authInfo.vipInfo.expired
    }
  }
}
